import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import { hasChildren, rootLinks } from '../common/utils/linkHierarchy';
import LabelDropdown from './components/LabelDropdown';
import LinkDropdown from './components/LinkDropdown';
import LinkItem from './components/LinkItem';
export default function extendHeader() {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    const allLinks = app.store.all('links');
    rootLinks(allLinks).forEach(link => {
      const key = `link${link.id()}`;
      if (hasChildren(allLinks, link)) {
        items.add(key, link.isLabel() ? m(LabelDropdown, {
          link: link
        }) : m(LinkDropdown, {
          link: link
        }));
      } else if (!link.isLabel()) {
        // A label with nothing under it has nothing to show.
        items.add(key, m(LinkItem, {
          link: link
        }));
      }
    });
  });
}